export default __webpack_public_path__ + "static/media/favorite.007c216e.svg";